export const TABLE_DATA = {
  heading: "Kubernetes Platforms Compared ",
  text: "What changes (and improves) when migrating to OneMind PaaS from other common Kubernetes environments: ",
  columns: ["Amazon EKS / AKS / GKE", "Self-Hosted K8s", "OneMind PaaS"],
  data: [
    {
      feature: "Cluster Provisioning",
      "Amazon EKS / AKS / GKE": "❌ Semi-automated",
      "Self-Hosted K8s": "❌ Manual",
      "OneMind PaaS": "✅ Fully managed by OneMind",
    },
    {
      feature: "Control Plane Management",
      "Amazon EKS / AKS / GKE": "❌ Managed (read-only)",
      "Self-Hosted K8s": "✅ Fully user-managed",
      "OneMind PaaS": "✅ Fully managed with full visibility",
    },
    {
      feature: "Observability",
      "Amazon EKS / AKS / GKE": "❌ Add-on services",
      "Self-Hosted K8s": "❌ Manual integration",
      "OneMind PaaS": "✅ Built-in (Grafana, Elastic, Prometheus)",
    },
    {
      feature: "CI/CD Integration",
      "Amazon EKS / AKS / GKE": "❌ BYO pipelines",
      "Self-Hosted K8s": "❌ Manual",
      "OneMind PaaS": "✅ Native GitOps, ArgoCD, GitHub/GitLab support",
    },
    {
      feature: "Storage Provisioning",
      "Amazon EKS / AKS / GKE": "❌ Cloud-dependent",
      "Self-Hosted K8s": "❌ Custom setup",
      "OneMind PaaS": "✅ Integrated dynamic provisioning",
    },
    {
      feature: "Multi-Cluster Support",
      "Amazon EKS / AKS / GKE": "❌ Limited",
      "Self-Hosted K8s": "❌ Possible, complex",
      "OneMind PaaS": "✅ Built-in with unified dashboard",
    },
    {
      feature: "Security/Compliance",
      "Amazon EKS / AKS / GKE": "❌ Cloud IAM, limited policy",
      "Self-Hosted K8s": "❌ DIY RBAC, policies",
      "OneMind PaaS": "✅ Preconfigured RBAC, network policies, backup & DR",
    },
    {
      feature: "Cost Visibility",
      "Amazon EKS / AKS / GKE": "❌ Metered billing",
      "Self-Hosted K8s": "❌ Hardware + ops cost",
      "OneMind PaaS": "✅ Predictable, service-based billing",
    },
  ],
};
